// Kdo je na tabletu přihlášený, když není signál (F4 4.5; rozhodnutí zadavatele 15. 9. 2026, 05/20).
//
// Přihlášení rozhoduje **server** (`GET /ja`, HttpOnly cookie relace — 08 §5.3). Bez signálu se ale server
// zeptat nejde a řidič po restartu tabletu uprostřed směny nesmí zůstat na hlášce „Nepodařilo se ověřit
// přihlášení“ s frontou zápisů v tabletu. Aplikace si proto poslední **úspěšnou** odpověď `/ja` uloží do
// tabletu a bez signálu podle ní jen kreslí (jaké sekce a tlačítka jsou vidět).
//
// Žádné právo tím nikdo nezíská: každý zápis jde na server s cookie relace a server ho ověří znovu (zápisy
// z fronty se zapisují **stejnou operací jako online**). Po obnovení signálu se profil hned načte znovu a
// když relace mezitím vypršela, aplikace pošle uživatele na přihlášení jako dřív.
import type { Ja } from '@ecoser/shared';
import { zapomenDochazkuZTabletu } from './dochazka-tabletu';
import { uloziste } from './uloziste';

const KLIC = 'ja';

let vPameti: Ja | undefined;

/** Profil, který má tablet po ruce (bez čtení z úložiště). */
export function jaVPameti(): Ja | undefined {
  return vPameti;
}

/** Uloží profil ze serveru do tabletu (volá se po každé úspěšné odpovědi `/ja`). */
export function ulozJaDoTabletu(ja: Ja): void {
  vPameti = ja;
  void uloziste()
    .uloz(KLIC, ja)
    .catch(() => {
      // Bez trvalého úložiště se profil drží jen v paměti — offline start po restartu tabletu pak nebude.
    });
}

/** Profil uložený v tabletu (po restartu tabletu bez signálu). */
export async function nactiJaZTabletu(): Promise<Ja | undefined> {
  if (vPameti) return vPameti;
  const ja = await uloziste()
    .ziskej<Ja>(KLIC)
    .catch(() => undefined);
  if (ja) vPameti = ja;
  return ja;
}

/**
 * Odhlášení: profil z tabletu pryč (jiný člověk na témže tabletu nesmí vidět cizí jméno a sekce) — i s uloženou
 * dnešní směnou (05/1141, `dochazka-tabletu.ts`).
 */
export async function zapomenJaZTabletu(): Promise<void> {
  vPameti = undefined;
  await uloziste()
    .smaz(KLIC)
    .catch(() => {});
  await zapomenDochazkuZTabletu();
}
